import * as React from "react";
import * as ReactDOM from "react-dom";
import { Map } from "immutable";
import { IOWidget, Pair, mk_pair, Sum, inl, inr, Widget, nothing } from "../widget";
import { any } from "./any"

export let onlyIf = function<a>(condition:boolean, widget:Widget<a>) : Widget<a> {
  return condition ? widget : nothing()
}
